module.exports = __webpack_public_path__ + "static/media/079.3bd6c8e0.jpg";